import { FC } from "react";
// 组件
import { PlusOutlined } from '@ant-design/icons';
// 方法
import classNames from "classnames";
// 常量
import { CardFooterProps } from "../../interface";

interface CardFooterInterProps extends CardFooterProps {
  /** 是否已经达到最大行 */
  isMaxLength?: boolean;
};
/** 卡片表单底部 */
const CardFooter: FC<CardFooterInterProps> = props => {
  const { addIcon, addText, showAdd, disabled, isMaxLength, maxLengthText, onAdd, } = props;
  const handleAdd = () => {
    if (isMaxLength) return;
    onAdd?.();
  };
  if (!showAdd || disabled) return null;
  return (
    <div className="form-card-footer">
      <div className={classNames('form-card-footer-add', { 'max-length': isMaxLength, })} onClick={handleAdd}>
        {
          !!addIcon && (
            <span className="form-card-footer-add-icon">{addIcon}</span>
          )
        }
        {
          !!addText && (
            <span className="form-card-footer-add-text">{addText}</span>
          )
        }
        {
          isMaxLength && !!maxLengthText && (
            <span className="form-card-footer-add-warning">({maxLengthText})</span>
          )
        }
      </div>
    </div>
  );
};

CardFooter.defaultProps = {
  addIcon: <PlusOutlined />,
  addText: '添加一行',
};

export default CardFooter;
